import React from 'react';
import { Filters } from 'react-data-grid-addons';

const { NumericFilter } = Filters;

export const defaultColumnProperties = {
	filterable: true,
	sortable: true,
	draggable: true,
	editable: true
};

const amountFormatter = ({ value }) => <div>${value}</div>;

export const columns = [
	{ key: 'txnID', name: 'Transaction ID', width: 150, },
	{ key: 'creationTime', name: 'Creation Time', width: 550, },
	{ key: 'amount', name: 'Amount', width: 150, formatter: amountFormatter },
	{ key: 'truckID', name: 'Truck Id', width: 550, },
	{ key: 'carrier', name: 'Carrier', width: 350, },
	{ key: 'date', name: 'Date', width: 150, },
	{ key: 'subDept', name: 'Subdept #', addLabel: 'Subdepartment #', width: 150, },
	{ key: 'driverPhone', name: 'Driver Phone #', width: 150, filterRenderer: NumericFilter },
	{ key: 'po_numbers', name: 'PO Number', addLabel: 'PO #', width: 250, },
	{ key: 'subDeptName', name: 'Subdept Name', addLabel: 'Subdepartment Name', width: 150, },
	{ key: 'vendor', name: 'Vendor', width: 550, },
	{ key: 'door', name: 'Door', width: 150, },
	{ key: 'status', name: 'Status', width: 300, },
	{ key: 'payType', name: 'Payment Type', width: 250, },
	{ key: 'payHost', name: 'Payment Host', width: 250, },
	{ key: 'authNumber', name: 'Auth Number', addLabel: 'Auth #', width: 150, },
	{ key: 'odometer', name: 'Odometer', width: 150, },
	{ key: 'wpToken', name: 'WP Token', width: 250, },
	{ key: 'paymentMedia', name: 'Payment Media', width: 250, },
	{ key: 'expressCode', name: 'Express Code', width: 250, },
].map(column => ({ ...column, ...defaultColumnProperties }));